import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pl-4 align-center" }
const _hoisted_2 = { class: "pl-4 align-center" }

import createOrUpdateSubManagementOffice from "@/types/requests/createOrUpdateSubManagementOffice"
import { computed } from 'vue';
import i18n from '@/lang/i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'TelephoneNumberForm',
  props: {
    modelValue: {},
    errors: {},
    windowInnerWidth: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emits = __emit

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, { class: "text-form pl-4 pr-3 mb-3" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, { cols: "2" }, {
        default: _withCtx(() => [
          _createElementVNode("h6", _hoisted_1, _toDisplayString(_unref(i18n).global.t('pages.subManagementOffice.telephoneNumber')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, { cols: "4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            modelValue: modelValue.value.telephone_number,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((modelValue.value.telephone_number) = $event)),
            maxlength: "11",
            "error-messages": __props.errors.telephone_number
          }, null, 8, ["modelValue", "error-messages"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, { cols: "2" }, {
        default: _withCtx(() => [
          _createElementVNode("h6", _hoisted_2, _toDisplayString(_unref(i18n).global.t('pages.subManagementOffice.form.faxNumber')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_v_col, { cols: "4" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            modelValue: modelValue.value.fax_number,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((modelValue.value.fax_number) = $event)),
            maxlength: "11",
            "error-messages": __props.errors.fax_number
          }, null, 8, ["modelValue", "error-messages"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})